export const pastDataArray = [
  {
    metricTitle: 'Health Expenditure Per Capita',
    category: 'Global Health',
    dataType: 'Current Expenditure per Capita (current US$)',
    conclusion: 'Upward Trend',
    data: [
      {
        year: '2009',
        value: '874',
      },
      {
        year: '2010',
        value: '912',
      },
      {
        year: '2011',
        value: '986',
      },
      {
        year: '2012',
        value: '996',
      },
      {
        year: '2013',
        value: '1012',
      },
      {
        year: '2014',
        value: '1035',
      },
      {
        year: '2015',
        value: '994',
      },
      {
        year: '2016',
        value: '1016',
      },
      {
        year: '2017',
        value: '1057',
      },
      {
        year: '2018',
        value: '1103',
      },
      {
        year: '2019',
        value: '1122',
      },
    ],
  },
  {
    metricTitle: 'Infant Mortality',
    category: 'Global Health',
    dataType: 'Mortality per 1000 Live Births (%)',
    conclusion: 'Steady Downward Trend',
    data: [
      {
        year: '2009',
        value: '38.6',
      },
      {
        year: '2010',
        value: '37.2',
      },
      {
        year: '2011',
        value: '35.8',
      },
      {
        year: '2012',
        value: '34.5',
      },
      {
        year: '2013',
        value: '33.3',
      },
      {
        year: '2014',
        value: '32.2',
      },
      {
        year: '2015',
        value: '31.2',
      },
      {
        year: '2016',
        value: '30.3',
      },
      {
        year: '2017',
        value: '29.4',
      },
      {
        year: '2018',
        value: '29',
      },
      {
        year: '2019',
        value: '28',
      },
      {
        year: '2020',
        value: '27',
      },
    ],
  },
  {
    metricTitle: 'Maternal Mortality',
    category: 'Global Health',
    dataType: '# of Maternal Deaths',
    conclusion: 'Steady Downward Trend',
    data: [
      {
        year: '2009',
        value: '354,000',
      },
      {
        year: '2010',
        value: '343,000',
      },
      {
        year: '2011',
        value: '334,000',
      },
      {
        year: '2012',
        value: '326,000',
      },
      {
        year: '2013',
        value: '319,000',
      },
      {
        year: '2014',
        value: '313,000',
      },
      {
        year: '2015',
        value: '306000',
      },
      {
        year: '2016',
        value: '300000',
      },
      {
        year: '2017',
        value: '295000',
      },
    ],
  },
  {
    metricTitle: 'Not in Extreme Poverty',
    category: 'Global Health',
    dataType: '% Not in Extreme Poverty',
    conclusion: 'Steady Upward Trend',
    data: [
      {
        year: '2010',
        value: '83.69',
      },
      {
        year: '2011',
        value: '85.87',
      },
      {
        year: '2015',
        value: '90.39',
      },
      {
        year: '2018',
        value: '91.4',
      },
    ],
  },
  {
    metricTitle: 'Access to Electricity',
    category: 'Global Health',
    dataType: '% of Global Population',
    conclusion: 'Upward Trend',
    data: [
      {
        year: '2009',
        value: '83.2',
      },
      {
        year: '2010',
        value: '83.5',
      },
      {
        year: '2011',
        value: '82.5',
      },
      {
        year: '2012',
        value: '85.0',
      },
      {
        year: '2013',
        value: '85.2',
      },
      {
        year: '2014',
        value: '85.7',
      },
      {
        year: '2015',
        value: '87.0',
      },
      {
        year: '2016',
        value: '87.4',
      },
      {
        year: '2017',
        value: '88.9',
      },
      {
        year: '2020',
        value: '90.5',
      },
    ],
  },
  {
    metricTitle: 'Happy Planet Index',
    category: 'Global Health',
    dataType: 'Average Happy Planet Index',
    conclusion: 'Pretty Steady Level',
    data: [
      {
        year: '2009',
        value: '44',
      },
      {
        year: '2010',
        value: '43.6',
      },
      {
        year: '2011',
        value: '44',
      },
      {
        year: '2012',
        value: '44.1',
      },
      {
        year: '2013',
        value: '44',
      },
      {
        year: '2014',
        value: '44.6',
      },
      {
        year: '2015',
        value: '44.3',
      },
      {
        year: '2016',
        value: '44.5',
      },
      {
        year: '2017',
        value: '44.3',
      },
      {
        year: '2018',
        value: '44.2',
      },
      {
        year: '2019',
        value: '44.1',
      },
      {
        year: '2020',
        value: '46',
      },
    ],
  },
  {
    metricTitle: 'Human Development Index',
    category: 'Global Health',
    dataType: 'Human Development Index',
    conclusion: 'Upward but Flattening Trend',
    data: [
      {
        year: '2009',
        value: '0.69',
      },
      {
        year: '2010',
        value: '0.697',
      },
      {
        year: '2011',
        value: '0.704',
      },
      {
        year: '2012',
        value: '0.709',
      },
      {
        year: '2013',
        value: '0.714',
      },
      {
        year: '2014',
        value: '0.72',
      },
      {
        year: '2015',
        value: '0.724',
      },
      {
        year: '2016',
        value: '0.729',
      },
      {
        year: '2017',
        value: '0.733',
      },
      {
        year: '2018',
        value: '0.736',
      },
      {
        year: '2019',
        value: '0.739',
      },
      {
        year: '2020',
        value: '0.735',
      },
    ],
  },
  {
    metricTitle: 'Renewable Energy',
    category: 'Global Health',
    dataType: 'Share of Global Electricity Production (%)',
    conclusion: 'Steady Upward Trend',
    data: [
      {
        year: '2009',
        value: '19.1',
      },
      {
        year: '2010',
        value: '19.4',
      },
      {
        year: '2011',
        value: '19.8',
      },
      {
        year: '2012',
        value: '20.6',
      },
      {
        year: '2013',
        value: '21.5',
      },
      {
        year: '2014',
        value: '22.0',
      },
      {
        year: '2015',
        value: '22.7',
      },
      {
        year: '2016',
        value: '23.5',
      },
      {
        year: '2017',
        value: '24.4',
      },
      {
        year: '2018',
        value: '25.0',
      },
      {
        year: '2019',
        value: '26.0',
      },
      {
        year: '2020',
        value: '27.9',
      },
    ],
  },
  {
    metricTitle: 'Women Members of National Parliments',
    category: 'Global Health',
    dataType: '% of representatives',
    conclusion: 'Steady Upward Trend',
    data: [
      {
        year: '2009',
        value: '19.02',
      },
      {
        year: '2010',
        value: '19.16',
      },
      {
        year: '2011',
        value: '19.83',
      },
      {
        year: '2012',
        value: '20.76',
      },
      {
        year: '2013',
        value: '21.78',
      },
      {
        year: '2014',
        value: '22.19',
      },
      {
        year: '2015',
        value: '22.85',
      },
      {
        year: '2016',
        value: '23.1',
      },
      {
        year: '2017',
        value: '23.6',
      },
      {
        year: '2018',
        value: '24.1',
      },
      {
        year: '2019',
        value: '24.64',
      },
      {
        year: '2020',
        value: '25.58',
      },
      {
        year: '2021',
        value: '26.13',
      },
    ],
  },
  {
    metricTitle: '% of Children Not in Primary School',
    category: 'Global Health',
    dataType: '% of Kids of Primary School Age',
    conclusion: 'Fluctuating Up and Down Trend',
    data: [
      {
        year: '2009',
        value: '9.00',
      },
      {
        year: '2010',
        value: '8.87',
      },
      {
        year: '2011',
        value: '8.89',
      },
      {
        year: '2012',
        value: '8.62',
      },
      {
        year: '2013',
        value: '8.37',
      },
      {
        year: '2014',
        value: '8.78',
      },
      {
        year: '2015',
        value: '8.99',
      },
      {
        year: '2016',
        value: '8.80',
      },
      {
        year: '2017',
        value: '8.78',
      },
      {
        year: '2018',
        value: '8.55',
      },
      {
        year: '2019',
        value: '8.64',
      },
      {
        year: '2020',
        value: '8.76',
      },
    ],
  },
  {
    metricTitle: 'Global CO2 Emissions',
    category: 'Global Health',
    dataType: 'Billion Tonnes',
    conclusion: 'Upward Trend with Fluctuations',
    data: [
      {
        year: '2009',
        value: '3.16',
      },
      {
        year: '2010',
        value: '3.34',
      },
      {
        year: '2011',
        value: '3.45',
      },
      {
        year: '2012',
        value: '3.50',
      },
      {
        year: '2013',
        value: '3.53',
      },
      {
        year: '2014',
        value: '3.56',
      },
      {
        year: '2015',
        value: '3.56',
      },
      {
        year: '2016',
        value: '3.55',
      },
      {
        year: '2017',
        value: '3.61',
      },
      {
        year: '2018',
        value: '3.68',
      },
      {
        year: '2019',
        value: '3.71',
      },
      {
        year: '2020',
        value: '3.53',
      },
      {
        year: '2021',
        value: '3.71',
      },
    ],
  },
  {
    metricTitle: 'GDP per capita',
    category: 'Global Health',
    dataType: '$USD',
    conclusion: 'Steady Upward Trend ',
    data: [
      {
        year: '2009',
        value: '13383',
      },
      {
        year: '2010',
        value: '13892',
      },
      {
        year: '2011',
        value: '14260',
      },
      {
        year: '2012',
        value: '14528',
      },
      {
        year: '2013',
        value: '14824',
      },
      {
        year: '2014',
        value: '15149',
      },
      {
        year: '2015',
        value: '15480',
      },
      {
        year: '2016',
        value: '15803',
      },
      {
        year: '2017',
        value: '16211',
      },
      {
        year: '2018',
        value: '16607',
      },
      {
        year: '2019',
        value: '16897',
      },
    ],
  },
  {
    metricTitle: 'GDP growth per capita',
    category: 'Global Health',
    dataType: '% Growth',
    conclusion: 'Fluctuating Up and Down Trend ',
    data: [
      {
        year: '2009',
        value: '-2.5',
      },
      {
        year: '2010',
        value: '3.25',
      },
      {
        year: '2011',
        value: '2.13',
      },
      {
        year: '2012',
        value: '1.43',
      },
      {
        year: '2013',
        value: '1.61',
      },
      {
        year: '2014',
        value: '1.89',
      },
      {
        year: '2015',
        value: '1.96',
      },
      {
        year: '2016',
        value: '1.64',
      },
      {
        year: '2017',
        value: '2.22',
      },
      {
        year: '2018',
        value: '2.14',
      },
      {
        year: '2019',
        value: '1.52',
      },
    ],
  },
  {
    metricTitle: 'Economic Freedom',
    category: 'Global Health',
    dataType: 'Economic Freedom',
    conclusion: 'Slight Upward Trend ',
    data: [
      {
        year: '2009',
        value: '59.5',
      },
      {
        year: '2010',
        value: '59.4',
      },
      {
        year: '2011',
        value: '59.7',
      },
      {
        year: '2012',
        value: '59.5',
      },
      {
        year: '2013',
        value: '59.6',
      },
      {
        year: '2014',
        value: '60.3',
      },
      {
        year: '2015',
        value: '60.4',
      },
      {
        year: '2016',
        value: '60.7',
      },
      {
        year: '2017',
        value: '60.9',
      },
      {
        year: '2018',
        value: '61.1',
      },
      {
        year: '2019',
        value: '60.8',
      },
    ],
  },
];
export const countries = [
  'None Selected',
  'Afghanistan',
  'Albania',
  'Algeria',
  'Angola',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo (Dem. Rep.)',
  'Congo (Rep.)',
  'Costa Rica',
  "Cote d'Ivoire",
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Estonia',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia, The',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Korea (Dem. People’s Rep.)',
  'Korea (Rep.)',
  'Kuwait',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Lithuania',
  'Luxembourg',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Moldova',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Namibia',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'South Africa',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkiye',
  'Turkmenistan',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];
// Dropdown Options
export const xMetricOptions = [
  { value: 'avgGDPpercapita', label: 'Average GDP Per Capita' },
  { value: 'latestGDPpercapita', label: 'Latest GDP Per Capita' },
  { value: 'GINI', label: 'Gini Inequality Index' },
  { value: 'avgHappyPlanet', label: 'Average Happy Planet Index' },
  { value: 'SEDA', label: 'Sustainable Development Index' },
];
export const metricCategoryOptions = [
  { value: 'allmetrics', label: 'All Metrics' },
  { value: 'economic', label: 'Economic Metrics' },
  { value: 'health', label: 'Health Metrics' },
  { value: 'sustainability', label: 'Sustainability Metrics' },
];
export const colorByOptions = [
  { value: 'Ranking', label: 'Color by: Ranking' },
  { value: 'Income', label: 'Color by: Income' },
  { value: 'Correlation', label: 'Color by: Correlation' },
  { value: 'Continent', label: 'Color by: Continent' },
];

// Custom Metrics
export const customMetricOptions = [
  {
    metricTitle: 'GINIindex',
    seriesName: 'GINI Index',
    domain: [0, 100],
    GDPcorrelation: 'Weak Negative',
    GINIcorrelation: 'Perfect',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Weak Negative',
    lowerText: 'LESS EQUAL',
    upperText: 'MORE EQUAL',
    subtitle:
      "See the relationship between country's level of inequality and their",
    definition:
      'Inequality in the distribution of family income. Lower is better.',
  },
  {
    metricTitle: 'happyplanetindex',
    seriesName: 'Happy Planet Index',
    GDPcorrelation: 'Weak Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'Perfect',
    SEDAcorrelation: 'No',
    domain: [0, 100],
    upperText: 'HAPPIER',
    subtitle:
      'See the relationship between the happiness of a country and their',
    definition:
      'A combo of well being, life expectancy, inequalities and ecological footprint. Higher is better.',
  },
  {
    metricTitle: 'humandevelopmentindex',
    seriesName: 'Human Development Index',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    domain: [0, 1],
    controlPosition: 'bottom',
    lowerText: 'LESS DEVELOPED',
    upperText: 'MORE DEVELOPED',
    definition:
      'Tracks basic dimensions of human development: long and healthy life, access to knowledge and standard of living. Higher is better.',
    subtitle:
      'A summary measure of average achievement in key areas of human development, see how a this index relates to ',
  },
  {
    metricTitle: 'sustainableeconomicdevelopmentassessmentSEDA',
    seriesName: 'Sustainable Economic Development Assessment',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Perfect',
    domain: [0, 100],
    controlPosition: 'bottom',
    upperText: 'MORE SUSTAINABLE',
    lowerText: 'LESS SUSTAINABLE',
    definition:
      'An assessment based on 40 indicators in sustainability, economics, & investments. Higher is better.',
    subtitle:
      'A way to understand a country’s overall social and economic conditions, see how a SEDA relates to ',
  },
  {
    metricTitle: 'GDPgrowthpercent',
    seriesName: 'Percent GDP Growth',
    GDPcorrelation: 'No',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'No',
    domain: [-15, 20],
    upperText: 'ECONOMY GROWING',
    lowerText: 'ECONOMY SHRINKING',
    definition:
      'Compares the year-over-year change in a country’s economic output to measure how fast an economy is growing.',
    subtitle:
      'See the relationship between the growth rate of a country’s GDP relates to',
  },
  {
    metricTitle: 'GDP',
    seriesName: 'Gross Domestic Product (GDP)',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    domain: [0, 23000],
    upperText: 'WEALTHIER',
    definition: 'A measure of a country’s economic output.',
    subtitle:
      'A measure of a country’s wealth, see how  Gross Domestic Product (GDP) relates to',
  },
  {
    metricTitle: 'GDPpercapita',
    seriesName: 'GDP Per Capita',
    GDPcorrelation: 'Perfect',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    domain: [0, 125000],
    upperText: 'WEALTHIER',
    definition:
      'A measure of a country’s economic output divided by the country’s population',
    subtitle: 'See how a country’s GDP on a per person level relates to',
  },
  {
    metricTitle: 'healthexpenditure',
    GDPcorrelation: 'Weak Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Weak Positive',
    seriesName: 'Percent of GDP Spent on Health',
    upperText: 'MORE SPENDING',
    lowerText: 'LESS SPENDING',
    domain: [0, 15],
    definition: 'Amount spent on health care as a percentage of GDP.',
    subtitle:
      'See how the amount a country spends on health care as a percentage of total GDP relates to',
  },
  {
    metricTitle: 'healthexpenditureperperson',
    seriesName: 'Health Expenditure Per Capita',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    upperText: 'MORE SPENDING PER PERSON',
    lowerText: 'LESS SPENDING',
    domain: [0, 12000],
    definition:
      'Amount spent on health care per person as a percentage of GDP.',
    subtitle:
      'See how a the amount a country spends on health care on a per person level relates to',
  },
  {
    metricTitle: 'infantmortality',
    seriesName: 'Infant Mortality',
    GDPcorrelation: 'Weak Negative',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'No',
    domain: [0, 100],
    upperText: 'HIGHER MORTALITY',
    definition: 'Infant mortalities per 1,000 live births.',
    subtitle:
      'Measured as mortalities per 1,000 live births, see how Infant Mortality relates to',
  },
  {
    metricTitle: 'maternalmortalityper100000livebirths',
    seriesName: 'Maternal Mortality',
    GDPcorrelation: 'Strong Negative',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Negative',
    domain: [0, 1200],
    upperText: 'HIGHER MORTALITY',
    definition: 'Maternal mortalities per 100,000 live births.',

    subtitle:
      'Measured as mortalities per 100,000 live births, see how Maternal Mortality relates to',
  },
  {
    metricTitle: 'educationexpenditure',
    seriesName: 'Percent of GDP Spent on Education',
    GDPcorrelation: 'Weak Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Weak Positive',
    upperText: 'MORE SPENDING',
    lowerText: 'LESS SPENDING',
    domain: [0, 20],
    definition: 'Amount spent on education as a percentage of GDP',
    subtitle:
      'See how the amount a country spends on educaiton as a percentage of total GDP relates to',
  },

  {
    metricTitle: 'kidsoutofprimary',
    seriesName: 'Percent of Eligible Kids not in Primary School',
    GDPcorrelation: 'Weak Negative',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Negative',
    domain: [0, 100],
    upperText: 'MORE KIDS OUT OF SCHOOL',
    definition: 'Percentage of primary-aged children are not attending school',
    subtitle:
      'See how the percent of primary-aged children not attending school relates to',
  },
  {
    metricTitle: 'unemployment',
    seriesName: 'Percent Unemployment',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    GDPcorrelation: 'Weak Negative',
    SEDAcorrelation: 'No',
    domain: [0, 30],
    definition: 'Percentage of labor force out of work',
    subtitle: 'See how the percent of the labor force is unemployed relates to',
  },
  {
    metricTitle: 'ofpopulationinextremepoverty',
    seriesName: 'Percent of Population in Extreme Poverity',
    GDPcorrelation: 'Strong Negative',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Negative',
    domain: [0, 30],
    upperText: 'MORE IN EXTREME POVERTY ',
    definition: 'Percentage of population earning less than $1.90 USD a day',
    subtitle:
      'Extreme Poverty is defined as earning less than $1.90 USD a day per person. See how this relates to ',
  },
  {
    metricTitle: 'ofpopulationwithaccesstoelectricity',
    seriesName: 'Percent of Population with Access to Electricity',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    domain: [0, 100],
    controlPosition: 'bottom',
    lowerText: 'LESS ACCESS ',
    definition: 'Percentage of population with access to electricity',
    subtitle: 'See how the a population’s access to electricity to',
  },
  {
    metricTitle: 'politicalrightsscore',
    seriesName: 'Political Rights Score',
    GDPcorrelation: 'Weak Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Weak Positive',
    upperText: 'MORE RIGHTS',
    lowerText: 'LESS RIGHTS',
    domain: [0, 40],
    controlPosition: 'bottom',
    definition: 'Part of the Freedom House’s Freedom in the World status',
    subtitle:
      'Part of the Freedom House’s Freedom in the World status, the Political Rights Score is out of 40. See how it relates to ',
  },
  {
    metricTitle: 'civillibertiesscore',
    seriesName: 'Civil Liberties Score',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Weak Positive',
    upperText: 'MORE LIBERTIES',
    lowerText: 'LESS LIBERTIES',
    domain: [0, 100],
    definition: 'Part of the Freedom House’s Freedom in the World status',
    subtitle:
      'Part of the Freedom House’s Freedom in the World status, the Civil Liberties Score is out of 60. See how it relates to ',
  },
  {
    metricTitle: 'politcalstability',
    seriesName: 'Political Stability and Absence of Violence',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    definition:
      "Part of the Worldwide Governance Indicator's six dimensions of governance",

    upperText: 'MORE STABLE',
    lowerText: 'LESS STABLE',
    domain: [-3, 2],
    controlPosition: 'bottom',
    subtitle:
      "One of the Worldwide Governance Indicator's six dimensions of governance, see how Political Stability and Absence of Violence relates to ",
  },
  {
    metricTitle: 'goveffectiveness',
    seriesName: 'Government Effectiveness',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',

    upperText: 'MORE EFFECTIVE',
    lowerText: 'LESS EFFECTIVE',
    domain: [-2.5, 2.5],
    controlPosition: 'bottom',
    definition:
      "Part of the Worldwide Governance Indicator's six dimensions of governance",

    subtitle:
      "One of the Worldwide Governance Indicator's six dimensions of governance, see how Government Effectiveness relates to ",
  },
  {
    metricTitle: 'regulatoryquality',
    seriesName: 'Regulatory Quality',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    upperText: 'HIGHER',
    lowerText: 'LOWER',
    domain: [-2.5, 2.5],
    controlPosition: 'bottom',
    definition:
      "Part of the Worldwide Governance Indicator's six dimensions of governance",

    subtitle:
      "One of the Worldwide Governance Indicator's six dimensions of governance, see how Regulatory Quality relates to ",
  },
  {
    metricTitle: 'ruleoflaw',
    seriesName: 'Rule of Law',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    domain: [-2.5, 2.5],
    upperText: 'STRONG',
    lowerText: 'WEAK',
    controlPosition: 'bottom',
    definition:
      "Part of the Worldwide Governance Indicator's six dimensions of governance",

    subtitle:
      "One of the Worldwide Governance Indicator's six dimensions of governance, see how Rule of Law relates to ",
  },
  {
    metricTitle: 'controlcorruption',
    seriesName: 'Control of Corruption',
    GDPcorrelation: 'Weak Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    domain: [-2.5, 2.5],
    upperText: 'HIGHER',
    lowerText: 'LOWER',
    controlPosition: 'bottom',
    definition:
      "Part of the Worldwide Governance Indicator's six dimensions of governance",

    subtitle:
      "One of the Worldwide Governance Indicator's six dimensions of governance, see how Control of Corruption relates to ",
  },
  {
    metricTitle: 'judicialeffectiveness',
    seriesName: 'Judicial Effectiveness',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Weak Positive',
    domain: [0, 100],
    upperText: 'MORE STABLE',
    lowerText: 'LESS STABLE',
    controlPosition: 'bottom',
    definition: "Part of the Heritage Foundation's Index of Economic Freedom",

    subtitle:
      "A part of the Heritage Foundation's Index of Economic Freedom, see how Judicial Effectiveness relates to",
  },
  {
    metricTitle: 'govintegrity',
    seriesName: 'Government Integrity',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    upperText: 'HIGHER',
    domain: [0, 100],
    controlPosition: 'bottom',
    definition: "Part of the Heritage Foundation's Index of Economic Freedom",

    subtitle:
      "A part of the Heritage Foundation's Index of Economic Freedom, see how Government Integrity relates to",
  },
  {
    metricTitle: 'economicfreedom',
    seriesName: 'Economic Freedom',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    GDPcorrelation: 'Strong Positive',
    upperText: 'HIGHER',
    domain: [0, 100],
    controlPosition: 'bottom',
    subtitle:
      "Made up of multiple sub-scores (see Governemnt Integrity, Judicial Effectiveness), see how the Heritage Foundation's Index of Economic Freedom relates to",
  },
  {
    metricTitle: 'finncialfreedom',
    seriesName: 'Financial Freedom',
    GDPcorrelation: 'Weak Positive',
    upperText: 'HIGHER',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Weak Positive',
    domain: [0, 100],
    controlPosition: 'bottom',
    definition: "Part of the Heritage Foundation's Index of Economic Freedom",

    subtitle:
      "A part of the Heritage Foundation's Index of Economic Freedom, see how Financial Freedom relates to",
  },
  {
    metricTitle: 'governmentexpenditure',
    seriesName: 'Government Expenditure',
    GDPcorrelation: 'Strong Positive',
    upperText: 'HIGHER',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    definition: "Part of the Heritage Foundation's Index of Economic Freedom",

    subtitle:
      "A part of the Heritage Foundation's Index of Economic Freedom, see how Government Expenditure relates to",

    domain: [0, 100],
  },
  {
    metricTitle: 'CO2eemissionspercapita',
    seriesName: 'CO2 Emissions per Capita',
    GDPcorrelation: 'Strong Positive',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'Strong Positive',
    definition: 'The amount of metric tons CO2 per person a country emits',
    upperText: 'HIGHER EMISSIONS',
    lowerText: 'LOWER EMISSIONS',
    domain: [0, 40],
    subtitle: 'See how the amount of CO2 per person a country emits relates to',
  },
  {
    metricTitle: 'renewableshare',
    seriesName: 'Share of Electricity from Renewables Generation',
    GDPcorrelation: 'No',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'No',
    upperText: 'HIGHER',
    lowerText: 'LOWER',
    domain: [0, 100],
    definition: 'Amount of electricty generated from renewable sources',
    subtitle:
      'See how the amount of electricty generated from renewable sources relates to',
  },
  {
    metricTitle: 'womenparliment',
    seriesName: 'Percent of Seats Held by Women in National Parliaments',
    GDPcorrelation: 'No',
    GINIcorrelation: 'Weak Negative',
    Happycorrelation: 'No',
    SEDAcorrelation: 'No',
    upperText: 'MAJORITY WOMEN',
    lowerText: 'MINORITY WOMEN',
    domain: [0, 70],
    definition: 'Percent of women holding seats in national parliment',
    subtitle:
      'See how the percent of women holding seats in national parliment relates to',
  },
  {
    metricTitle: 'militaryspending',
    seriesName: 'Military Spending as Percent of GDP',
    GDPcorrelation: 'No',
    GINIcorrelation: 'No',
    Happycorrelation: 'No',
    SEDAcorrelation: 'No',
    upperText: 'HIGHER',
    domain: [0, 20],
    definition: 'Amount spent on militart as percent of GDP',
    subtitle:
      'See how the amount of money spent on the military as a percent of GDP relates to',
  },
];

// default
export const defaultSelectedMetric = {
  metricTitle: 'GINIindex',
  url: 'https://www.cia.gov/library/publications/the-world-factbook/rankorder/2172rank.html',
  notes: 'inequality in the distribution of family income. Lower the better.',
  data: [
    {
      country: 'Afghanistan',
      continent: 'Asia',
      incomeLevel: 'Lower Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 77,
      avgGDPpercapita: 2104,
      latestGDP: 76.7,
      latestGDPpercapita: 2078,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: 24.8,
      latestHappyPlanet: 29.4,
      population: 36000000,
    },
    {
      country: 'Albania',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 29,
      latestVal: 29,
      year: '',
      avgGDP: 38.9,
      avgGDPpercapita: 14194,
      latestGDP: 40.8,
      latestGDPpercapita: 15646,
      SEDA: 53.1,
      GINI: 29,
      avgHappyPlanet: 43.9,
      latestHappyPlanet: 51,
      population: 2900000,
    },
    {
      country: 'Algeria',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 35.3,
      latestVal: 35.3,
      year: '',
      avgGDP: 486.7,
      avgGDPpercapita: 11819,
      latestGDP: 488.9,
      latestGDPpercapita: 12037,
      SEDA: 45.8,
      GINI: 35.3,
      avgHappyPlanet: 39.9,
      latestHappyPlanet: 46.5,
      population: 41000000,
    },
    {
      country: 'Angola',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 42.7,
      latestVal: 42.7,
      year: '',
      avgGDP: 208.5,
      avgGDPpercapita: 6801,
      latestGDP: 203.3,
      latestGDPpercapita: 6581,
      SEDA: 28.4,
      GINI: 42.7,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 30000000,
    },
    {
      country: 'Argentina',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: 41.7,
      latestVal: 41.7,
      year: '',
      avgGDP: 970.6,
      avgGDPpercapita: 22671,
      latestGDP: 985.2,
      latestGDPpercapita: 23627,
      SEDA: 57.3,
      GINI: 41.7,
      avgHappyPlanet: 42.6,
      latestHappyPlanet: 50,
      population: 44000000,
    },
    {
      country: 'Armenia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 31.5,
      latestVal: 31.5,
      year: '',
      avgGDP: 38.7,
      avgGDPpercapita: 13798,
      latestGDP: 39.5,
      latestGDPpercapita: 14630,
      SEDA: 51.7,
      GINI: 31.5,
      avgHappyPlanet: 40.2,
      latestHappyPlanet: 54.7,
      population: 3000000,
    },
    {
      country: 'Australia',
      continent: 'Oceania',
      incomeLevel: 'High Income',
      avgVal: 30.3,
      latestVal: 30.3,
      year: '',
      avgGDP: 1248.9,
      avgGDPpercapita: 52760,
      latestGDP: 1269.2,
      latestGDPpercapita: 55807,
      SEDA: 78.9,
      GINI: 30.3,
      avgHappyPlanet: 32.15,
      latestHappyPlanet: 43.1,
      population: 25000000,
    },
    {
      country: 'Austria',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 30.5,
      latestVal: 30.5,
      year: '',
      avgGDP: 482.5,
      avgGDPpercapita: 57287,
      latestGDP: 483.1,
      latestGDPpercapita: 58427,
      SEDA: 80.3,
      GINI: 30.5,
      avgHappyPlanet: 38.65,
      latestHappyPlanet: 46.8,
      population: 9000000,
    },
    {
      country: 'Azerbaijan',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 33.7,
      latestVal: 33.7,
      year: '',
      avgGDP: 142.7,
      avgGDPpercapita: 14981,
      latestGDP: 146.3,
      latestGDPpercapita: 15843,
      SEDA: 51.1,
      GINI: 33.7,
      avgHappyPlanet: 48,
      latestHappyPlanet: 48,
      population: 10000000,
    },
    {
      country: 'Bahamas',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 12.8,
      avgGDPpercapita: 34575,
      latestGDP: 12.3,
      latestGDPpercapita: 34108,
      SEDA: 60.4,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 400000,
    },
    {
      country: 'Bahrain',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 72.5,
      avgGDPpercapita: 45986,
      latestGDP: 72.3,
      latestGDPpercapita: 45411,
      SEDA: 63.9,
      GINI: null,
      avgHappyPlanet: 33.6,
      latestHappyPlanet: 33.6,
      population: 1300000,
    },
    {
      country: 'Bangladesh',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 32.1,
      latestVal: 32.1,
      year: '',
      avgGDP: 920.2,
      avgGDPpercapita: 5929,
      latestGDP: 1001.1,
      latestGDPpercapita: 6613,
      SEDA: 35.3,
      GINI: 32.1,
      avgHappyPlanet: 46.45,
      latestHappyPlanet: 54.5,
      population: 165000000,
    },
    {
      country: 'Barbados',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 4.2,
      avgGDPpercapita: 15251,
      latestGDP: 3.9,
      latestGDPpercapita: 14817,
      SEDA: 60.8,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 300000,
    },
    {
      country: 'Belarus',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 26.5,
      latestVal: 26.5,
      year: '',
      avgGDP: 181.3,
      avgGDPpercapita: 20364,
      latestGDP: 184.5,
      latestGDPpercapita: 21699,
      SEDA: 59.9,
      GINI: 26.5,
      avgHappyPlanet: 32.3,
      latestHappyPlanet: 42.9,
      population: 10000000,
    },
    {
      country: 'Belgium',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 25.9,
      latestVal: 25.9,
      year: '',
      avgGDP: 585.5,
      avgGDPpercapita: 54704,
      latestGDP: 598,
      latestGDPpercapita: 58931,
      SEDA: 77.5,
      GINI: 25.9,
      avgHappyPlanet: 33.1,
      latestHappyPlanet: 42.5,
      population: 11000000,
    },
    {
      country: 'Belize',
      continent: 'North America',
      incomeLevel: 'Upper Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 2.6,
      avgGDPpercapita: 6965,
      latestGDP: 2.6,
      latestGDPpercapita: 6921,
      SEDA: 48.5,
      GINI: null,
      avgHappyPlanet: 33.8,
      latestHappyPlanet: 33.8,
      population: 400000,
    },
    {
      country: 'Benin',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 36.5,
      latestVal: 36.5,
      year: '',
      avgGDP: 39.6,
      avgGDPpercapita: 3489,
      latestGDP: 42.9,
      latestGDPpercapita: 3789,
      SEDA: 34.5,
      GINI: 36.5,
      avgHappyPlanet: 27.4,
      latestHappyPlanet: 41.4,
      population: 11000000,
    },
    {
      country: 'Bhutan',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 38.8,
      latestVal: 38.8,
      year: '',
      avgGDP: 8.6,
      avgGDPpercapita: 11705,
      latestGDP: 8.1,
      latestGDPpercapita: 11129,
      SEDA: 47.7,
      GINI: 38.8,
      avgHappyPlanet: 32.65,
      latestHappyPlanet: 36.7,
      population: 800000,
    },
    {
      country: 'Bolivia',
      continent: 'South America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 47,
      latestVal: 47,
      year: '',
      avgGDP: 96.9,
      avgGDPpercapita: 8817,
      latestGDP: 97.3,
      latestGDPpercapita: 9030,
      SEDA: 44.8,
      GINI: 47,
      avgHappyPlanet: 34.15,
      latestHappyPlanet: 45,
      population: 11000000,
    },
    {
      country: 'Bosnia and Herzegovina',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 33.8,
      latestVal: 33.8,
      year: '',
      avgGDP: 48.9,
      avgGDPpercapita: 15769,
      latestGDP: 51,
      latestGDPpercapita: 16846,
      SEDA: 50.2,
      GINI: 33.8,
      avgHappyPlanet: 36.55,
      latestHappyPlanet: 47.8,
      population: 3900000,
    },
    {
      country: 'Botswana',
      continent: 'Africa',
      incomeLevel: 'High Income',
      avgVal: 60.5,
      latestVal: 60.5,
      year: '',
      avgGDP: 36.8,
      avgGDPpercapita: 16695,
      latestGDP: 38.4,
      latestGDPpercapita: 17604,
      SEDA: 44.1,
      GINI: 60.5,
      avgHappyPlanet: 24.25,
      latestHappyPlanet: 31.9,
      population: 2200000,
    },
    {
      country: 'Brazil',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: 49,
      latestVal: 49,
      year: '',
      avgGDP: 3074.9,
      avgGDPpercapita: 15317,
      latestGDP: 3127.5,
      latestGDPpercapita: 16056,
      SEDA: 51.6,
      GINI: 49,
      avgHappyPlanet: 44.45,
      latestHappyPlanet: 54.6,
      population: 209000000,
    },
    {
      country: 'Brunei',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 26.7,
      avgGDPpercapita: 64694,
      latestGDP: 26.8,
      latestGDPpercapita: 66620,
      SEDA: 72.5,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 400000,
    },
    {
      country: 'Bulgaria',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 40.2,
      latestVal: 40.2,
      year: '',
      avgGDP: 158.8,
      avgGDPpercapita: 24696,
      latestGDP: 161.7,
      latestGDPpercapita: 26705,
      SEDA: 59.9,
      GINI: 40.2,
      avgHappyPlanet: 30.25,
      latestHappyPlanet: 40.1,
      population: 7000000,
    },
    {
      country: 'Burkina Faso',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 39.5,
      latestVal: 39.5,
      year: '',
      avgGDP: 44.8,
      avgGDPpercapita: 2293,
      latestGDP: 48.2,
      latestGDPpercapita: 2462,
      SEDA: 33.4,
      GINI: 39.5,
      avgHappyPlanet: 29.7,
      latestHappyPlanet: 41.5,
      population: 19000000,
    },
    {
      country: 'Burundi',
      continent: 'Africa',
      incomeLevel: 'Low Income',
      avgVal: 42.4,
      latestVal: 42.4,
      year: '',
      avgGDP: 8.7,
      avgGDPpercapita: 782,
      latestGDP: 8.8,
      latestGDPpercapita: 793,
      SEDA: 28.3,
      GINI: 42.4,
      avgHappyPlanet: 26.65,
      latestHappyPlanet: 37.7,
      population: 11000000,
    },
    {
      country: 'Cabo Verde',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 3.7,
      avgGDPpercapita: 6977,
      latestGDP: 3.6,
      latestGDPpercapita: 7028,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 500000,
    },
    {
      country: 'Cambodia',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 37.9,
      latestVal: 37.9,
      year: '',
      avgGDP: 70.6,
      avgGDPpercapita: 4485,
      latestGDP: 72.2,
      latestGDPpercapita: 4683,
      SEDA: 38.5,
      GINI: 37.9,
      avgHappyPlanet: 36.8,
      latestHappyPlanet: 48,
      population: 16000000,
    },
    {
      country: 'Cameroon',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 44.6,
      latestVal: 44.6,
      year: '',
      avgGDP: 97.1,
      avgGDPpercapita: 3908,
      latestGDP: 100.7,
      latestGDPpercapita: 4064,
      SEDA: 32.1,
      GINI: 44.6,
      avgHappyPlanet: 28.3,
      latestHappyPlanet: 39.9,
      population: 24000000,
    },
    {
      country: 'Canada',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: 32.1,
      latestVal: 32.1,
      year: '',
      avgGDP: 1812,
      avgGDPpercapita: 49487,
      latestGDP: 1832.1,
      latestGDPpercapita: 52085,
      SEDA: 76.9,
      GINI: 32.1,
      avgHappyPlanet: 32.05,
      latestHappyPlanet: 40.2,
      population: 37000000,
    },
    {
      country: 'Central African Republic',
      continent: 'Africa',
      incomeLevel: 'Low Income',
      avgVal: 43.6,
      latestVal: 43.6,
      year: '',
      avgGDP: 4.5,
      avgGDPpercapita: 988,
      latestGDP: 4.6,
      latestGDPpercapita: 1021,
      SEDA: 16.1,
      GINI: 43.6,
      avgHappyPlanet: 25.2,
      latestHappyPlanet: 25.2,
      population: 4900000,
    },
    {
      country: 'Chad',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 43.3,
      latestVal: 43.3,
      year: '',
      avgGDP: 24.7,
      avgGDPpercapita: 1611,
      latestGDP: 24.5,
      latestGDPpercapita: 1591,
      SEDA: 20.4,
      GINI: 43.3,
      avgHappyPlanet: 21.6,
      latestHappyPlanet: 30.4,
      population: 15000000,
    },
    {
      country: 'Chile',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: 50.5,
      latestVal: 50.5,
      year: '',
      avgGDP: 470.4,
      avgGDPpercapita: 26261,
      latestGDP: 496.1,
      latestGDPpercapita: 29104,
      SEDA: 62.6,
      GINI: 50.5,
      avgHappyPlanet: 38.65,
      latestHappyPlanet: 45.6,
      population: 18000000,
    },
    {
      country: 'China',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 46.5,
      latestVal: 46.5,
      year: '',
      avgGDP: 22894.9,
      avgGDPpercapita: 17169,
      latestGDP: 24861.3,
      latestGDPpercapita: 19338,
      SEDA: 50.8,
      GINI: 46.5,
      avgHappyPlanet: 33.8,
      latestHappyPlanet: 41.9,
      population: 1386000000,
    },
    {
      country: 'Colombia',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: 51.1,
      latestVal: 51.1,
      year: '',
      avgGDP: 720,
      avgGDPpercapita: 15620,
      latestGDP: 753.9,
      latestGDPpercapita: 16894,
      SEDA: 49.1,
      GINI: 51.1,
      avgHappyPlanet: 50.45,
      latestHappyPlanet: 60.2,
      population: 49000000,
    },
    {
      country: 'Comoros',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 55.9,
      latestVal: 55.9,
      year: '',
      avgGDP: 2.6,
      avgGDPpercapita: 3192,
      latestGDP: 2.7,
      latestGDPpercapita: 3284,
      SEDA: null,
      GINI: 55.9,
      avgHappyPlanet: 32.75,
      latestHappyPlanet: 42.4,
      population: 800000,
    },
    {
      country: 'Congo (Dem. Rep.)',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 42.1,
      latestVal: 42.1,
      year: '',
      avgGDP: 96.5,
      avgGDPpercapita: 1154,
      latestGDP: 102.5,
      latestGDPpercapita: 1219,
      SEDA: 24.8,
      GINI: 42.1,
      avgHappyPlanet: 40.5,
      latestHappyPlanet: 40.5,
      population: 81000000,
    },
    {
      country: 'Congo (Rep.)',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 48.9,
      latestVal: 48.9,
      year: '',
      avgGDP: 19.8,
      avgGDPpercapita: 3829,
      latestGDP: 18.6,
      latestGDPpercapita: 3617,
      SEDA: 32.7,
      GINI: 48.9,
      avgHappyPlanet: 33,
      latestHappyPlanet: 47.2,
      population: 4500000,
    },
    {
      country: 'Costa Rica',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: 48.5,
      latestVal: 48.5,
      year: '',
      avgGDP: 105,
      avgGDPpercapita: 22396,
      latestGDP: 109.3,
      latestGDPpercapita: 23387,
      SEDA: 58.9,
      GINI: 48.5,
      avgHappyPlanet: 53.4,
      latestHappyPlanet: 62.1,
      population: 4900000,
    },
    {
      country: "Cote d'Ivoire",
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 41.5,
      latestVal: 41.5,
      year: '',
      avgGDP: 135.8,
      avgGDPpercapita: 5498,
      latestGDP: 146.3,
      latestGDPpercapita: 5940,
      SEDA: 30.5,
      GINI: 41.5,
      avgHappyPlanet: 27,
      latestHappyPlanet: 39.6,
      population: 24000000,
    },
    {
      country: 'Croatia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 30.8,
      latestVal: 30.8,
      year: '',
      avgGDP: 116.3,
      avgGDPpercapita: 30501,
      latestGDP: 121.1,
      latestGDPpercapita: 33801,
      SEDA: 64.5,
      GINI: 30.8,
      avgHappyPlanet: 38.2,
      latestHappyPlanet: 46.2,
      population: 4200000,
    },
    {
      country: 'Cuba',
      continent: 'North America',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: null,
      avgGDPpercapita: null,
      latestGDP: null,
      latestGDPpercapita: null,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 11000000,
    },
    {
      country: 'Cyprus',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 34.8,
      latestVal: 34.8,
      year: '',
      avgGDP: 35.7,
      avgGDPpercapita: 41262,
      latestGDP: 36.7,
      latestGDPpercapita: 42556,
      SEDA: 65.9,
      GINI: 34.8,
      avgHappyPlanet: 40.05,
      latestHappyPlanet: 49.4,
      population: 800000,
    },
    {
      country: 'Czech Republic',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 424.9,
      avgGDPpercapita: 42463,
      latestGDP: 425.8,
      latestGDPpercapita: 44261,
      SEDA: 71.1,
      GINI: null,
      avgHappyPlanet: 37.05,
      latestHappyPlanet: 46.8,
      population: 11000000,
    },
    {
      country: 'Denmark',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 29,
      latestVal: 29,
      year: '',
      avgGDP: 331,
      avgGDPpercapita: 60266,
      latestGDP: 340.8,
      latestGDPpercapita: 64651,
      SEDA: 82,
      GINI: 29,
      avgHappyPlanet: 39,
      latestHappyPlanet: 45.3,
      population: 6000000,
    },
    {
      country: 'Djibouti',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 40.9,
      latestVal: 40.9,
      year: '',
      avgGDP: 5.1,
      avgGDPpercapita: 5530,
      latestGDP: 5.4,
      latestGDPpercapita: 5926,
      SEDA: null,
      GINI: 40.9,
      avgHappyPlanet: 16.4,
      latestHappyPlanet: 16.4,
      population: 1000000,
    },
    {
      country: 'Dominican Republic',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: 47.1,
      latestVal: 47.1,
      year: '',
      avgGDP: 194.4,
      avgGDPpercapita: 19007,
      latestGDP: 207.1,
      latestGDPpercapita: 20769,
      SEDA: 48.1,
      GINI: 47.1,
      avgHappyPlanet: 42.55,
      latestHappyPlanet: 54.8,
      population: 11000000,
    },
    {
      country: 'Ecuador',
      continent: 'South America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 45.9,
      latestVal: 45.9,
      year: '',
      avgGDP: 191.8,
      avgGDPpercapita: 11560,
      latestGDP: 189.9,
      latestGDPpercapita: 11661,
      SEDA: 48.1,
      GINI: 45.9,
      avgHappyPlanet: 47.9,
      latestHappyPlanet: 58.8,
      population: 17000000,
    },
    {
      country: 'Egypt',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 31.8,
      latestVal: 31.8,
      year: '',
      avgGDP: 1196.6,
      avgGDPpercapita: 12455,
      latestGDP: 1263.7,
      latestGDPpercapita: 13316,
      SEDA: 43.1,
      GINI: 31.8,
      avgHappyPlanet: 33.5,
      latestHappyPlanet: 43.2,
      population: 98000000,
    },
    {
      country: 'El Salvador',
      continent: 'North America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 36,
      latestVal: 36,
      year: '',
      avgGDP: 55.3,
      avgGDPpercapita: 9014,
      latestGDP: 57.4,
      latestGDPpercapita: 9669,
      SEDA: 47.2,
      GINI: 36,
      avgHappyPlanet: 45.95,
      latestHappyPlanet: 56.3,
      population: 6000000,
    },
    {
      country: 'Equatorial Guinea',
      continent: 'Africa',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 25,
      avgGDPpercapita: 19136,
      latestGDP: 23.9,
      latestGDPpercapita: 18127,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 800000,
    },
    {
      country: 'Eritrea',
      continent: 'Africa',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: null,
      avgGDPpercapita: null,
      latestGDP: null,
      latestGDPpercapita: null,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 5000000,
    },
    {
      country: 'Estonia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 34.8,
      latestVal: 34.8,
      year: '',
      avgGDP: 48.1,
      avgGDPpercapita: 38484,
      latestGDP: 50.8,
      latestGDPpercapita: 42192,
      SEDA: 70.8,
      GINI: 34.8,
      avgHappyPlanet: 26.15,
      latestHappyPlanet: 34.4,
      population: 1300000,
    },
    {
      country: 'Eswatini',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 50.4,
      latestVal: 50.4,
      year: '',
      avgGDP: 10,
      avgGDPpercapita: 9106,
      latestGDP: 10.5,
      latestGDPpercapita: 9816,
      SEDA: null,
      GINI: 50.4,
      avgHappyPlanet: 25.4,
      latestHappyPlanet: 35.3,
      population: 1100000,
    },
    {
      country: 'Ethiopia',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 33,
      latestVal: 33,
      year: '',
      avgGDP: 255.4,
      avgGDPpercapita: 2373,
      latestGDP: 278.9,
      latestGDPpercapita: 2600,
      SEDA: 32.3,
      GINI: 33,
      avgHappyPlanet: 34.2,
      latestHappyPlanet: 41.7,
      population: 105000000,
    },
    {
      country: 'Fiji',
      continent: 'Oceania',
      incomeLevel: 'Upper Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 11.2,
      avgGDPpercapita: 13164,
      latestGDP: 9.9,
      latestGDPpercapita: 12060,
      SEDA: 49,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 900000,
    },
    {
      country: 'Finland',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 27.2,
      latestVal: 27.2,
      year: '',
      avgGDP: 266.6,
      avgGDPpercapita: 51461,
      latestGDP: 271.2,
      latestGDPpercapita: 55007,
      SEDA: 81.3,
      GINI: 27.2,
      avgHappyPlanet: 41.3,
      latestHappyPlanet: 51.3,
      population: 6000000,
    },
    {
      country: 'France',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 29.3,
      latestVal: 29.3,
      year: '',
      avgGDP: 3008.7,
      avgGDPpercapita: 48342,
      latestGDP: 3050.1,
      latestGDPpercapita: 50729,
      SEDA: 73.9,
      GINI: 29.3,
      avgHappyPlanet: 41.1,
      latestHappyPlanet: 51.8,
      population: 67000000,
    },
    {
      country: 'Gabon',
      continent: 'Africa',
      incomeLevel: 'High Income',
      avgVal: 42.2,
      latestVal: 42.2,
      year: '',
      avgGDP: 32,
      avgGDPpercapita: 15344,
      latestGDP: 32.4,
      latestGDPpercapita: 15598,
      SEDA: 40.9,
      GINI: 42.2,
      avgHappyPlanet: 28.7,
      latestHappyPlanet: 39.9,
      population: 1900000,
    },
    {
      country: 'Gambia, The',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 50.2,
      latestVal: 50.2,
      year: '',
      avgGDP: 5.2,
      avgGDPpercapita: 2310,
      latestGDP: 5.5,
      latestGDPpercapita: 2434,
      SEDA: null,
      GINI: 50.2,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 2100000,
    },
    {
      country: 'Georgia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 40.1,
      latestVal: 40.1,
      year: '',
      avgGDP: 54.6,
      avgGDPpercapita: 15486,
      latestGDP: 57.4,
      latestGDPpercapita: 16997,
      SEDA: 55.4,
      GINI: 40.1,
      avgHappyPlanet: 37.7,
      latestHappyPlanet: 44.3,
      population: 3700000,
    },
    {
      country: 'Germany',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 27,
      latestVal: 27,
      year: '',
      avgGDP: 4398,
      avgGDPpercapita: 55915,
      latestGDP: 4400.1,
      latestGDPpercapita: 57928,
      SEDA: 79.6,
      GINI: 27,
      avgHappyPlanet: 41.25,
      latestHappyPlanet: 52.7,
      population: 83000000,
    },
    {
      country: 'Ghana',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 42.3,
      latestVal: 42.3,
      year: '',
      avgGDP: 168.6,
      avgGDPpercapita: 5786,
      latestGDP: 178.5,
      latestGDPpercapita: 6178,
      SEDA: 40.2,
      GINI: 42.3,
      avgHappyPlanet: 30.45,
      latestHappyPlanet: 39.5,
      population: 29000000,
    },
    {
      country: 'Greece',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 36.7,
      latestVal: 36.7,
      year: '',
      avgGDP: 308.7,
      avgGDPpercapita: 29804,
      latestGDP: 313.8,
      latestGDPpercapita: 31295,
      SEDA: 64.1,
      GINI: 36.7,
      avgHappyPlanet: 36.2,
      latestHappyPlanet: 48.8,
      population: 11000000,
    },
    {
      country: 'Guatemala',
      continent: 'North America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 53,
      latestVal: 53,
      year: '',
      avgGDP: 143.9,
      avgGDPpercapita: 9076,
      latestGDP: 152.1,
      latestGDPpercapita: 9769,
      SEDA: 42.5,
      GINI: 53,
      avgHappyPlanet: 46.05,
      latestHappyPlanet: 57.9,
      population: 17000000,
    },
    {
      country: 'Guinea',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 39.4,
      latestVal: 39.4,
      year: '',
      avgGDP: 33.4,
      avgGDPpercapita: 2717,
      latestGDP: 35.4,
      latestGDPpercapita: 2879,
      SEDA: 28.3,
      GINI: 39.4,
      avgHappyPlanet: 38.1,
      latestHappyPlanet: 38.1,
      population: 13000000,
    },
    {
      country: 'Guinea-Bissau',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 3.7,
      avgGDPpercapita: 1994,
      latestGDP: 3.8,
      latestGDPpercapita: 2057,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 1700000,
    },
    {
      country: 'Guyana',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: 44.6,
      latestVal: 44.6,
      year: '',
      avgGDP: 13.1,
      avgGDPpercapita: 17652,
      latestGDP: 17.6,
      latestGDPpercapita: 24494,
      SEDA: 42.8,
      GINI: 44.6,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 800000,
    },
    {
      country: 'Haiti',
      continent: 'North America',
      incomeLevel: 'Lower Middle Income',
      avgVal: 60.8,
      latestVal: 60.8,
      year: '',
      avgGDP: 34,
      avgGDPpercapita: 3167,
      latestGDP: 32.9,
      latestGDPpercapita: 3127,
      SEDA: 24.2,
      GINI: 60.8,
      avgHappyPlanet: 33.4,
      latestHappyPlanet: 38.2,
      population: 11000000,
    },
    {
      country: 'Honduras',
      continent: 'North America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 47.1,
      latestVal: 47.1,
      year: '',
      avgGDP: 54.6,
      avgGDPpercapita: 5867,
      latestGDP: 57.3,
      latestGDPpercapita: 6253,
      SEDA: 41.9,
      GINI: 47.1,
      avgHappyPlanet: 42.45,
      latestHappyPlanet: 57.7,
      population: 9000000,
    },
    {
      country: 'Hungary',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 28.2,
      latestVal: 28.2,
      year: '',
      avgGDP: 312.9,
      avgGDPpercapita: 62392,
      latestGDP: 325.5,
      latestGDPpercapita: 65973,
      SEDA: 66.1,
      GINI: 28.2,
      avgHappyPlanet: 35.9,
      latestHappyPlanet: 45.4,
      population: 10000000,
    },
    {
      country: 'Iceland',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 28,
      latestVal: 28,
      year: '',
      avgGDP: 19.9,
      avgGDPpercapita: 33864,
      latestGDP: 19.9,
      latestGDPpercapita: 36753,
      SEDA: 83.7,
      GINI: 28,
      avgHappyPlanet: 39.55,
      latestHappyPlanet: 48,
      population: 300000,
    },
    {
      country: 'India',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 35.2,
      latestVal: 35.2,
      year: '',
      avgGDP: 8947.7,
      avgGDPpercapita: 6875,
      latestGDP: 9301.5,
      latestGDPpercapita: 7334,
      SEDA: 40,
      GINI: 35.2,
      avgHappyPlanet: 32.8,
      latestHappyPlanet: 36.4,
      population: 1339000000,
    },
    {
      country: 'Indonesia',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 36.8,
      latestVal: 36.8,
      year: '',
      avgGDP: 3154.3,
      avgGDPpercapita: 12233,
      latestGDP: 3246.2,
      latestGDPpercapita: 12904,
      SEDA: 46.4,
      GINI: 36.8,
      avgHappyPlanet: 42.65,
      latestHappyPlanet: 49.6,
      population: 264000000,
    },
    {
      country: 'Iran',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 44.5,
      latestVal: 44.5,
      year: '',
      avgGDP: 1248.6,
      avgGDPpercapita: 15667,
      latestGDP: 1257.5,
      latestGDPpercapita: 15791,
      SEDA: 48,
      GINI: 44.5,
      avgHappyPlanet: 33.8,
      latestHappyPlanet: 43.6,
      population: 81000000,
    },
    {
      country: 'Iraq',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 400.9,
      avgGDPpercapita: 10630,
      latestGDP: 390.2,
      latestGDPpercapita: 10409,
      SEDA: 37,
      GINI: null,
      avgHappyPlanet: 35.9,
      latestHappyPlanet: 45.3,
      population: 38000000,
    },
    {
      country: 'Ireland',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 31.3,
      latestVal: 31.3,
      year: '',
      avgGDP: 450.3,
      avgGDPpercapita: 92935,
      latestGDP: 513.7,
      latestGDPpercapita: 106456,
      SEDA: 80.3,
      GINI: 31.3,
      avgHappyPlanet: 40.55,
      latestHappyPlanet: 51.1,
      population: 4700000,
    },
    {
      country: 'Israel',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 42.8,
      latestVal: 42.8,
      year: '',
      avgGDP: 367.9,
      avgGDPpercapita: 40780,
      latestGDP: 389.4,
      latestGDPpercapita: 43722,
      SEDA: 66.5,
      GINI: 42.8,
      avgHappyPlanet: 38.5,
      latestHappyPlanet: 48.2,
      population: 9000000,
    },
    {
      country: 'Italy',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 31.9,
      latestVal: 31.9,
      year: '',
      avgGDP: 2473.4,
      avgGDPpercapita: 43834,
      latestGDP: 2477.1,
      latestGDPpercapita: 45936,
      SEDA: 69.1,
      GINI: 31.9,
      avgHappyPlanet: 39.4,
      latestHappyPlanet: 50.7,
      population: 61000000,
    },
    {
      country: 'Jamaica',
      continent: 'North America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 35,
      latestVal: 35,
      year: '',
      avgGDP: 27.6,
      avgGDPpercapita: 9856,
      latestGDP: 27.1,
      latestGDPpercapita: 10026,
      SEDA: 49.7,
      GINI: 35,
      avgHappyPlanet: 47.4,
      latestHappyPlanet: 57.9,
      population: 2800000,
    },
    {
      country: 'Japan',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 37.9,
      latestVal: 37.9,
      year: '',
      avgGDP: 5184.9,
      avgGDPpercapita: 42360,
      latestGDP: 5124,
      latestGDPpercapita: 42940,
      SEDA: 75.2,
      GINI: 37.9,
      avgHappyPlanet: 37.7,
      latestHappyPlanet: 47.1,
      population: 127000000,
    },
    {
      country: 'Jordan',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 39.7,
      latestVal: 39.7,
      year: '',
      avgGDP: 101,
      avgGDPpercapita: 10514,
      latestGDP: 102.4,
      latestGDPpercapita: 10952,
      SEDA: 48.7,
      GINI: 39.7,
      avgHappyPlanet: 43.9,
      latestHappyPlanet: 43.9,
      population: 10000000,
    },
    {
      country: 'Kazakhstan',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 26.3,
      latestVal: 26.3,
      year: '',
      avgGDP: 481.3,
      avgGDPpercapita: 27242,
      latestGDP: 494.7,
      latestGDPpercapita: 28600,
      SEDA: 57.7,
      GINI: 26.3,
      avgHappyPlanet: 28.85,
      latestHappyPlanet: 38.6,
      population: 18000000,
    },
    {
      country: 'Kenya',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 48.5,
      latestVal: 48.5,
      year: '',
      avgGDP: 235.7,
      avgGDPpercapita: 4675,
      latestGDP: 251.4,
      latestGDPpercapita: 5024,
      SEDA: 35.4,
      GINI: 48.5,
      avgHappyPlanet: 34.7,
      latestHappyPlanet: 45.2,
      population: 50000000,
    },
    {
      country: 'Korea (Dem. People’s Rep.)',
      continent: 'Asia',
      incomeLevel: 'Lower Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: null,
      avgGDPpercapita: 2187,
      latestGDP: null,
      latestGDPpercapita: 2172,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 25000000,
    },
    {
      country: 'Korea (Rep.)',
      incomeLevel: 'High Income',
      continent: 'Asia',
      avgVal: 35.7,
      latestVal: 35.7,
      year: '',
      avgGDP: 2213.9,
      avgGDPpercapita: null,
      latestGDP: 2282.8,
      latestGDPpercapita: null,
      SEDA: null,
      GINI: 35.7,
      avgHappyPlanet: 32.3,
      latestHappyPlanet: 39.8,
      population: 51000000,
    },
    {
      country: 'Kosovo',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 23.2,
      latestVal: 23.2,
      year: '',
      avgGDP: 19.9,
      avgGDPpercapita: 44547,
      latestGDP: 20.9,
      latestGDPpercapita: 46918,
      SEDA: null,
      GINI: 23.2,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 1900000,
    },
    {
      country: 'Kuwait',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 204.3,
      avgGDPpercapita: 50550,
      latestGDP: 191.5,
      latestGDPpercapita: 47303,
      SEDA: 65.7,
      GINI: null,
      avgHappyPlanet: 33.3,
      latestHappyPlanet: 33.3,
      population: 4200000,
    },
    {
      country: 'Kyrgyzstan',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 33.4,
      latestVal: 33.4,
      year: '',
      avgGDP: 32.4,
      avgGDPpercapita: 5252,
      latestGDP: 32.2,
      latestGDPpercapita: 5288,
      SEDA: 45.4,
      GINI: 33.4,
      avgHappyPlanet: 43.4,
      latestHappyPlanet: 53.7,
      population: 6000000,
    },
    {
      country: 'Laos',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 36.7,
      latestVal: 36.7,
      year: '',
      avgGDP: 56.3,
      avgGDPpercapita: 8227,
      latestGDP: 58.3,
      latestGDPpercapita: 8674,
      SEDA: 37.8,
      GINI: 36.7,
      avgHappyPlanet: 42.8,
      latestHappyPlanet: 42.8,
      population: 7000000,
    },
    {
      country: 'Latvia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 34.5,
      latestVal: 34.5,
      year: '',
      avgGDP: 58.5,
      avgGDPpercapita: 32163,
      latestGDP: 59.7,
      latestGDPpercapita: 34469,
      SEDA: 66.1,
      GINI: 34.5,
      avgHappyPlanet: 25.6,
      latestHappyPlanet: 34.1,
      population: 2000000,
    },
    {
      country: 'Lebanon',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 86.4,
      avgGDPpercapita: 13277,
      latestGDP: 65.9,
      latestGDPpercapita: 10691,
      SEDA: 44.8,
      GINI: null,
      avgHappyPlanet: 30.45,
      latestHappyPlanet: 39,
      population: 4600000,
    },
    {
      country: 'Lesotho',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 63.2,
      latestVal: 63.2,
      year: '',
      avgGDP: 5.4,
      avgGDPpercapita: 2674,
      latestGDP: 5.3,
      latestGDPpercapita: 2682,
      SEDA: 29.5,
      GINI: 63.2,
      avgHappyPlanet: 22,
      latestHappyPlanet: 27.3,
      population: 1900000,
    },
    {
      country: 'Liberia',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 32,
      latestVal: 32,
      year: '',
      avgGDP: 7.3,
      avgGDPpercapita: 1533,
      latestGDP: 7.3,
      latestGDPpercapita: 1553,
      SEDA: 30.6,
      GINI: 32,
      avgHappyPlanet: 34.1,
      latestHappyPlanet: 46,
      population: 4400000,
    },
    {
      country: 'Libya',
      continent: 'Africa',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 143.8,
      avgGDPpercapita: 22241,
      latestGDP: 147.9,
      latestGDPpercapita: 23357,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: 42.7,
      latestHappyPlanet: 42.7,
      population: 6000000,
    },
    {
      country: 'Lithuania',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 37.9,
      latestVal: 37.9,
      year: '',
      avgGDP: 103.9,
      avgGDPpercapita: 39116,
      latestGDP: 108.9,
      latestGDPpercapita: 42665,
      SEDA: 67.4,
      GINI: 37.9,
      avgHappyPlanet: 28.95,
      latestHappyPlanet: 36.9,
      population: 2900000,
    },
    {
      country: 'Luxembourg',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 30.4,
      latestVal: 30.4,
      year: '',
      avgGDP: 72.2,
      avgGDPpercapita: 121727,
      latestGDP: 75.8,
      latestGDPpercapita: 134754,
      SEDA: 83.2,
      GINI: 30.4,
      avgHappyPlanet: 22.45,
      latestHappyPlanet: 31.7,
      population: 600000,
    },
    {
      country: 'Macedonia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 33.7,
      latestVal: 33.7,
      year: '',
      avgGDP: 33.8,
      avgGDPpercapita: 17245,
      latestGDP: 34,
      latestGDPpercapita: 17918,
      SEDA: 52.5,
      GINI: 33.7,
      avgHappyPlanet: 33.65,
      latestHappyPlanet: 43.9,
      population: 2100000,
    },
    {
      country: 'Madagascar',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 41,
      latestVal: 41,
      year: '',
      avgGDP: 42.1,
      avgGDPpercapita: 1624,
      latestGDP: 42.3,
      latestGDPpercapita: 1635,
      SEDA: 31.1,
      GINI: 41,
      avgHappyPlanet: 44.2,
      latestHappyPlanet: 44.2,
      population: 26000000,
    },
    {
      country: 'Malawi',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 46.1,
      latestVal: 46.1,
      year: '',
      avgGDP: 28.6,
      avgGDPpercapita: 1596,
      latestGDP: 29.7,
      latestGDPpercapita: 1658,
      SEDA: 32.5,
      GINI: 46.1,
      avgHappyPlanet: 30.4,
      latestHappyPlanet: 38.7,
      population: 19000000,
    },
    {
      country: 'Malaysia',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 46.2,
      latestVal: 46.2,
      year: '',
      avgGDP: 879.5,
      avgGDPpercapita: 28849,
      latestGDP: 883.6,
      latestGDPpercapita: 29617,
      SEDA: 59.8,
      GINI: 46.2,
      avgHappyPlanet: 36,
      latestHappyPlanet: 41.7,
      population: 32000000,
    },
    {
      country: 'Maldives',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 38.4,
      latestVal: 38.4,
      year: '',
      avgGDP: 9,
      avgGDPpercapita: 17813,
      latestGDP: 9,
      latestGDPpercapita: 18232,
      SEDA: null,
      GINI: 38.4,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 400000,
    },
    {
      country: 'Mali',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 40.1,
      latestVal: 40.1,
      year: '',
      avgGDP: 45.2,
      avgGDPpercapita: 2388,
      latestGDP: 46.5,
      latestGDPpercapita: 2447,
      SEDA: 29.7,
      GINI: 40.1,
      avgHappyPlanet: 39.3,
      latestHappyPlanet: 39.3,
      population: 19000000,
    },
    {
      country: 'Malta',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 28.1,
      latestVal: 28.1,
      year: '',
      avgGDP: 22.1,
      avgGDPpercapita: 45984,
      latestGDP: 22.9,
      latestGDPpercapita: 47714,
      SEDA: 68.8,
      GINI: 28.1,
      avgHappyPlanet: 36.25,
      latestHappyPlanet: 43.5,
      population: 400000,
    },
    {
      country: 'Mauritania',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 37,
      latestVal: 37,
      year: '',
      avgGDP: 23.8,
      avgGDPpercapita: 5467,
      latestGDP: 24.3,
      latestGDPpercapita: 5592,
      SEDA: 28.9,
      GINI: 37,
      avgHappyPlanet: 26.35,
      latestHappyPlanet: 34.7,
      population: 3800000,
    },
    {
      country: 'Mauritius',
      continent: 'Africa',
      incomeLevel: 'High Income',
      avgVal: 35.9,
      latestVal: 35.9,
      year: '',
      avgGDP: 26.8,
      avgGDPpercapita: 22336,
      latestGDP: 25.6,
      latestGDPpercapita: 22240,
      SEDA: 60.2,
      GINI: 35.9,
      avgHappyPlanet: 39.45,
      latestHappyPlanet: 51.5,
      population: 1300000,
    },
    {
      country: 'Mexico',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: 48.2,
      latestVal: 48.2,
      year: '',
      avgGDP: 2436.4,
      avgGDPpercapita: 19666,
      latestGDP: 2415.7,
      latestGDPpercapita: 20036,
      SEDA: 49.1,
      GINI: 48.2,
      avgHappyPlanet: 47.5,
      latestHappyPlanet: 54.3,
      population: 129000000,
    },
    {
      country: 'Moldova',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 26.8,
      latestVal: 26.8,
      year: '',
      avgGDP: 34.2,
      avgGDPpercapita: 13703,
      latestGDP: 36.6,
      latestGDPpercapita: 15637,
      SEDA: 48.7,
      GINI: 26.8,
      avgHappyPlanet: 51,
      latestHappyPlanet: 51,
      population: 3600000,
    },
    {
      country: 'Mongolia',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 34,
      latestVal: 34,
      year: '',
      avgGDP: 39,
      avgGDPpercapita: 12639,
      latestGDP: 39,
      latestGDPpercapita: 12863,
      SEDA: 50.6,
      GINI: 34,
      avgHappyPlanet: 19.4,
      latestHappyPlanet: 24.5,
      population: 3000000,
    },
    {
      country: 'Montenegro',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 31.9,
      latestVal: 31.9,
      year: '',
      avgGDP: 12.6,
      avgGDPpercapita: 21843,
      latestGDP: 12.8,
      latestGDPpercapita: 22795,
      SEDA: null,
      GINI: 31.9,
      avgHappyPlanet: 33.2,
      latestHappyPlanet: 41.3,
      population: 600000,
    },
    {
      country: 'Morocco',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 40.9,
      latestVal: 40.9,
      year: '',
      avgGDP: 273.9,
      avgGDPpercapita: 7751,
      latestGDP: 281.4,
      latestGDPpercapita: 8144,
      SEDA: 45.8,
      GINI: 40.9,
      avgHappyPlanet: 41.8,
      latestHappyPlanet: 50.9,
      population: 36000000,
    },
    {
      country: 'Mozambique',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 45.6,
      latestVal: 45.6,
      year: '',
      avgGDP: 38.7,
      avgGDPpercapita: 1324,
      latestGDP: 39.3,
      latestGDPpercapita: 1342,
      SEDA: 26.7,
      GINI: 45.6,
      avgHappyPlanet: 33.95,
      latestHappyPlanet: 44.2,
      population: 30000000,
    },
    {
      country: 'Myanmar',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 244.3,
      avgGDPpercapita: 4746,
      latestGDP: 216.8,
      latestGDPpercapita: 4345,
      SEDA: 37,
      GINI: null,
      avgHappyPlanet: 32.35,
      latestHappyPlanet: 40,
      population: 53000000,
    },
    {
      country: 'Namibia',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 59.7,
      latestVal: 59.7,
      year: '',
      avgGDP: 23.7,
      avgGDPpercapita: 9929,
      latestGDP: 23.1,
      latestGDPpercapita: 9805,
      SEDA: 39.1,
      GINI: 59.7,
      avgHappyPlanet: 29.2,
      latestHappyPlanet: 36.8,
      population: 2300000,
    },
    {
      country: 'Nepal',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 32.8,
      latestVal: 32.8,
      year: '',
      avgGDP: 111.2,
      avgGDPpercapita: 14374,
      latestGDP: 115.1,
      latestGDPpercapita: 15103,
      SEDA: 41.7,
      GINI: 32.8,
      avgHappyPlanet: 41.8,
      latestHappyPlanet: 53.1,
      population: 29000000,
    },
    {
      country: 'Netherlands',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 30.3,
      latestVal: 30.3,
      year: '',
      avgGDP: 973.4,
      avgGDPpercapita: 59966,
      latestGDP: 995.2,
      latestGDPpercapita: 63767,
      SEDA: 80.3,
      GINI: 30.3,
      avgHappyPlanet: 45.1,
      latestHappyPlanet: 54.9,
      population: 17000000,
    },
    {
      country: 'New Zealand',
      continent: 'Oceania',
      incomeLevel: 'High Income',
      avgVal: 36.2,
      latestVal: 36.2,
      year: '',
      avgGDP: 214.6,
      avgGDPpercapita: 44788,
      latestGDP: 221.8,
      latestGDPpercapita: 46420,
      SEDA: 78.6,
      GINI: 36.2,
      avgHappyPlanet: 44.35,
      latestHappyPlanet: 57.4,
      population: 4700000,
    },
    {
      country: 'Nicaragua',
      continent: 'North America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 47.1,
      latestVal: 47.1,
      year: '',
      avgGDP: 36.6,
      avgGDPpercapita: 5862,
      latestGDP: 38.6,
      latestGDPpercapita: 6332,
      SEDA: 43.5,
      GINI: 47.1,
      avgHappyPlanet: 46.95,
      latestHappyPlanet: 55.2,
      population: 6000000,
    },
    {
      country: 'Niger',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 34,
      latestVal: 34,
      year: '',
      avgGDP: 28.8,
      avgGDPpercapita: 1276,
      latestGDP: 30,
      latestGDPpercapita: 1310,
      SEDA: null,
      GINI: 34,
      avgHappyPlanet: 29.1,
      latestHappyPlanet: 41.4,
      population: 21000000,
    },
    {
      country: 'Nigeria',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 48.8,
      latestVal: 48.8,
      year: '',
      avgGDP: 1026.5,
      avgGDPpercapita: 5319,
      latestGDP: 1050.5,
      latestGDPpercapita: 5459,
      SEDA: 26.5,
      GINI: 48.8,
      avgHappyPlanet: 28.15,
      latestHappyPlanet: 34.1,
      population: 191000000,
    },
    {
      country: 'Norway',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 26.8,
      latestVal: 26.8,
      year: '',
      avgGDP: 345.8,
      avgGDPpercapita: 69613,
      latestGDP: 355.3,
      latestGDPpercapita: 79201,
      SEDA: 85.3,
      GINI: 26.8,
      avgHappyPlanet: 43.85,
      latestHappyPlanet: 50.9,
      population: 5000000,
    },
    {
      country: 'Oman',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 154.6,
      avgGDPpercapita: 32365,
      latestGDP: 150.7,
      latestGDPpercapita: 31118,
      SEDA: 62.1,
      GINI: null,
      avgHappyPlanet: 21.1,
      latestHappyPlanet: 21.1,
      population: 4000000,
    },
    {
      country: 'Pakistan',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 30.7,
      latestVal: 30.7,
      year: '',
      avgGDP: 1154.1,
      avgGDPpercapita: 5567,
      latestGDP: 1204.9,
      latestGDPpercapita: 5878,
      SEDA: 27.9,
      GINI: 30.7,
      avgHappyPlanet: 38.3,
      latestHappyPlanet: 45.1,
      population: 197000000,
    },
    {
      country: 'Panama',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: 50.7,
      latestVal: 50.7,
      year: '',
      avgGDP: 124.8,
      avgGDPpercapita: 30752,
      latestGDP: 126.4,
      latestGDPpercapita: 31680,
      SEDA: 54.5,
      GINI: 50.7,
      avgHappyPlanet: 48.7,
      latestHappyPlanet: 57.9,
      population: 4000000,
    },
    {
      country: 'Papua New Guinea',
      continent: 'Oceania',
      incomeLevel: 'Upper Middle Income',
      avgVal: 50.9,
      latestVal: 50.9,
      year: '',
      avgGDP: 36.7,
      avgGDPpercapita: 4374,
      latestGDP: 36.9,
      latestGDPpercapita: 4445,
      SEDA: null,
      GINI: 50.9,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 8000000,
    },
    {
      country: 'Paraguay',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: 51.7,
      latestVal: 51.7,
      year: '',
      avgGDP: 89.5,
      avgGDPpercapita: 13323,
      latestGDP: 91.8,
      latestGDPpercapita: 13976,
      SEDA: 46.2,
      GINI: 51.7,
      avgHappyPlanet: 35.45,
      latestHappyPlanet: 47.6,
      population: 7000000,
    },
    {
      country: 'Peru',
      continent: 'South America',
      incomeLevel: 'Upper Middle Income',
      avgVal: 45.3,
      latestVal: 45.3,
      year: '',
      avgGDP: 405.3,
      avgGDPpercapita: 13073,
      latestGDP: 421.9,
      latestGDPpercapita: 13895,
      SEDA: 49.3,
      GINI: 45.3,
      avgHappyPlanet: 45.25,
      latestHappyPlanet: 55.9,
      population: 32000000,
    },
    {
      country: 'Philippines',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 44.4,
      latestVal: 44.4,
      year: '',
      avgGDP: 916.5,
      avgGDPpercapita: 8881,
      latestGDP: 921.8,
      latestGDPpercapita: 9120,
      SEDA: 44.5,
      GINI: 44.4,
      avgHappyPlanet: 46.05,
      latestHappyPlanet: 57.1,
      population: 105000000,
    },
    {
      country: 'Poland',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 30.8,
      latestVal: 30.8,
      year: '',
      avgGDP: 1247.2,
      avgGDPpercapita: 34385,
      latestGDP: 1298.3,
      latestGDPpercapita: 37503,
      SEDA: 67.7,
      GINI: 30.8,
      avgHappyPlanet: 36.25,
      latestHappyPlanet: 45,
      population: 38000000,
    },
    {
      country: 'Portugal',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 33.9,
      latestVal: 33.9,
      year: '',
      avgGDP: 346,
      avgGDPpercapita: 35291,
      latestGDP: 345.2,
      latestGDPpercapita: 35888,
      SEDA: 70.8,
      GINI: 33.9,
      avgHappyPlanet: 35.55,
      latestHappyPlanet: 46.3,
      population: 10000000,
    },
    {
      country: 'Qatar',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 250.8,
      avgGDPpercapita: 92618,
      latestGDP: 249.5,
      latestGDPpercapita: 93521,
      SEDA: 70.8,
      GINI: null,
      avgHappyPlanet: 24.3,
      latestHappyPlanet: 24.3,
      population: 2600000,
    },
    {
      country: 'Romania',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 27.3,
      latestVal: 27.3,
      year: '',
      avgGDP: 570.3,
      avgGDPpercapita: 32206,
      latestGDP: 589.8,
      latestGDPpercapita: 35414,
      SEDA: 60,
      GINI: 27.3,
      avgHappyPlanet: 37.5,
      latestHappyPlanet: 46.2,
      population: 20000000,
    },
    {
      country: 'Russia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 41.2,
      latestVal: 41.2,
      year: '',
      avgGDP: 3971.7,
      avgGDPpercapita: 30402,
      latestGDP: 4080.3,
      latestGDPpercapita: 32803,
      SEDA: 57,
      GINI: 41.2,
      avgHappyPlanet: 26.8,
      latestHappyPlanet: 34.9,
      population: 144000000,
    },
    {
      country: 'Rwanda',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 50.4,
      latestVal: 50.4,
      year: '',
      avgGDP: 27.8,
      avgGDPpercapita: 2292,
      latestGDP: 30.1,
      latestGDPpercapita: 2494,
      SEDA: 38,
      GINI: 50.4,
      avgHappyPlanet: 29.4,
      latestHappyPlanet: 39.2,
      population: 12000000,
    },
    {
      country: 'Saudi Arabia',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 45.9,
      latestVal: 45.9,
      year: '',
      avgGDP: 1588.5,
      avgGDPpercapita: 48520,
      latestGDP: 1594,
      latestGDPpercapita: 49551,
      SEDA: 62.6,
      GINI: 45.9,
      avgHappyPlanet: 41.6,
      latestHappyPlanet: 41.6,
      population: 33000000,
    },
    {
      country: 'Senegal',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 40.3,
      latestVal: 40.3,
      year: '',
      avgGDP: 55.5,
      avgGDPpercapita: 3543,
      latestGDP: 59,
      latestGDPpercapita: 3769,
      SEDA: 38.4,
      GINI: 40.3,
      avgHappyPlanet: 36.55,
      latestHappyPlanet: 51.2,
      population: 16000000,
    },
    {
      country: 'Serbia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 38.7,
      latestVal: 38.7,
      year: '',
      avgGDP: 127.6,
      avgGDPpercapita: 19267,
      latestGDP: 135.3,
      latestGDPpercapita: 21432,
      SEDA: 54.9,
      GINI: 38.7,
      avgHappyPlanet: 41.1,
      latestHappyPlanet: 53.2,
      population: 7000000,
    },
    {
      country: 'Sierra Leone',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 34,
      latestVal: 34,
      year: '',
      avgGDP: 13.1,
      avgGDPpercapita: 1754,
      latestGDP: 13.5,
      latestGDPpercapita: 1816,
      SEDA: 32.9,
      GINI: 34,
      avgHappyPlanet: 22.15,
      latestHappyPlanet: 29,
      population: 8000000,
    },
    {
      country: 'Singapore',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 45.9,
      latestVal: 45.9,
      year: '',
      avgGDP: 557.7,
      avgGDPpercapita: 104821,
      latestGDP: 578.3,
      latestGDPpercapita: 116486,
      SEDA: 81.8,
      GINI: 45.9,
      avgHappyPlanet: 45.5,
      latestHappyPlanet: 45.5,
      population: 6000000,
    },
    {
      country: 'Slovakia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 23.7,
      latestVal: 23.7,
      year: '',
      avgGDP: 170.5,
      avgGDPpercapita: 31887,
      latestGDP: 171.6,
      latestGDPpercapita: 33010,
      SEDA: 67.4,
      GINI: 23.7,
      avgHappyPlanet: 37.4,
      latestHappyPlanet: 46.6,
      population: 5000000,
    },
    {
      country: 'Slovenia',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 24.4,
      latestVal: 24.4,
      year: '',
      avgGDP: 80.6,
      avgGDPpercapita: 40746,
      latestGDP: 84.2,
      latestGDPpercapita: 43625,
      SEDA: 72.6,
      GINI: 24.4,
      avgHappyPlanet: 36.25,
      latestHappyPlanet: 47.9,
      population: 2100000,
    },
    {
      country: 'Solomon Islands',
      continent: 'Oceania',
      incomeLevel: 'Lower Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 829.7,
      avgGDPpercapita: 2702,
      latestGDP: 832.1,
      latestGDPpercapita: 2656,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 600000,
    },
    {
      country: 'Somalia',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 1.7,
      avgGDPpercapita: 1235,
      latestGDP: 1.7,
      latestGDPpercapita: 1302,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 15000000,
    },
    {
      country: 'South Africa',
      continent: 'Africa',
      incomeLevel: 'High Income',
      avgVal: 62.5,
      latestVal: 62.5,
      year: '',
      avgGDP: 18.4,
      avgGDPpercapita: 14069,
      latestGDP: 19.4,
      latestGDPpercapita: 14420,
      SEDA: 38.5,
      GINI: 62.5,
      avgHappyPlanet: 26.05,
      latestHappyPlanet: 36.2,
      population: 57000000,
    },
    {
      country: 'South Sudan',
      continent: 'Africa',
      avgVal: 46,
      latestVal: 46,
      year: '',
      avgGDP: 786,
      avgGDPpercapita: null,
      latestGDP: 788.1,
      latestGDPpercapita: null,
      SEDA: null,
      GINI: 46,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 13000000,
    },
    {
      country: 'Spain',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 35.9,
      latestVal: 35.9,
      year: '',
      avgGDP: 1831.3,
      avgGDPpercapita: 40231,
      latestGDP: 1803,
      latestGDPpercapita: 40775,
      SEDA: 71.8,
      GINI: 35.9,
      avgHappyPlanet: 44.15,
      latestHappyPlanet: 52.3,
      population: 47000000,
    },
    {
      country: 'Sri Lanka',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 39.2,
      latestVal: 39.2,
      year: '',
      avgGDP: 280.9,
      avgGDPpercapita: 13538,
      latestGDP: 284.9,
      latestGDPpercapita: 14127,
      SEDA: 49.3,
      GINI: 39.2,
      avgHappyPlanet: 40.3,
      latestHappyPlanet: 46.8,
      population: 21000000,
    },
    {
      country: 'Sudan',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 176.5,
      avgGDPpercapita: 4296,
      latestGDP: 172.4,
      latestGDPpercapita: 4217,
      SEDA: 26.5,
      GINI: null,
      avgHappyPlanet: 39.6,
      latestHappyPlanet: 39.6,
      population: 41000000,
    },
    {
      country: 'Suriname',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 10.1,
      avgGDPpercapita: 18177,
      latestGDP: 9,
      latestGDPpercapita: 16676,
      SEDA: 52.7,
      GINI: null,
      avgHappyPlanet: 25.4,
      latestHappyPlanet: 25.4,
      population: 600000,
    },
    {
      country: 'Sweden',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 24.9,
      latestVal: 24.9,
      year: '',
      avgGDP: 538.9,
      avgGDPpercapita: 55627,
      latestGDP: 552.6,
      latestGDPpercapita: 59324,
      SEDA: 81.9,
      GINI: 24.9,
      avgHappyPlanet: 39.25,
      latestHappyPlanet: 50.5,
      population: 10000000,
    },
    {
      country: 'Switzerland',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 29.5,
      latestVal: 29.5,
      year: '',
      avgGDP: 604.8,
      avgGDPpercapita: 73191,
      latestGDP: 615.7,
      latestGDPpercapita: 77324,
      SEDA: 83.8,
      GINI: 29.5,
      avgHappyPlanet: 47.2,
      latestHappyPlanet: 60.1,
      population: 8000000,
    },
    {
      country: 'Syria',
      continent: 'Asia',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: null,
      avgGDPpercapita: null,
      latestGDP: null,
      latestGDPpercapita: null,
      SEDA: null,
      GINI: null,
      avgHappyPlanet: 19.1,
      latestHappyPlanet: 19.1,
      population: 18000000,
    },
    {
      country: 'Taiwan',
      continent: 'Asia',
      avgVal: 33.6,
      latestVal: 33.6,
      year: '',
      avgGDP: null,
      avgGDPpercapita: null,
      latestGDP: null,
      latestGDPpercapita: null,
      SEDA: null,
      GINI: 33.6,
      avgHappyPlanet: 43.2,
      latestHappyPlanet: 43.2,
      population: 24000000,
    },
    {
      country: 'Tajikistan',
      continent: 'Asia',
      incomeLevel: 'Lower Middle Income',
      avgVal: 32.6,
      latestVal: 32.6,
      year: '',
      avgGDP: 34.3,
      avgGDPpercapita: 3843,
      latestGDP: 38.1,
      latestGDPpercapita: 4288,
      SEDA: 41.3,
      GINI: 32.6,
      avgHappyPlanet: 44.7,
      latestHappyPlanet: 55.2,
      population: 9000000,
    },
    {
      country: 'Tanzania',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 37.6,
      latestVal: 37.6,
      year: '',
      avgGDP: 150.9,
      avgGDPpercapita: 2784,
      latestGDP: 159.3,
      latestGDPpercapita: 2933,
      SEDA: 36,
      GINI: 37.6,
      avgHappyPlanet: 29.55,
      latestHappyPlanet: 37,
      population: 57000000,
    },
    {
      country: 'Thailand',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 44.5,
      latestVal: 44.5,
      year: '',
      avgGDP: 1242,
      avgGDPpercapita: 18790,
      latestGDP: 1223.1,
      latestGDPpercapita: 19209,
      SEDA: 52.4,
      GINI: 44.5,
      avgHappyPlanet: 45.1,
      latestHappyPlanet: 52.9,
      population: 69000000,
    },
    {
      country: 'Timor-Leste',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 31.9,
      latestVal: 31.9,
      year: '',
      avgGDP: 4.8,
      avgGDPpercapita: 3877,
      latestGDP: 5.4,
      latestGDPpercapita: 4418,
      SEDA: null,
      GINI: 31.9,
      avgHappyPlanet: null,
      latestHappyPlanet: null,
      population: 1200000,
    },
    {
      country: 'Togo',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 46,
      latestVal: 46,
      year: '',
      avgGDP: 17.3,
      avgGDPpercapita: 2231,
      latestGDP: 18.4,
      latestGDPpercapita: 2380,
      SEDA: 34.9,
      GINI: 46,
      avgHappyPlanet: 25.25,
      latestHappyPlanet: 37.3,
      population: 8000000,
    },
    {
      country: 'Trinidad and Tobago',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 36,
      avgGDPpercapita: 27142,
      latestGDP: 34.3,
      latestGDPpercapita: 26868,
      SEDA: 58.7,
      GINI: null,
      avgHappyPlanet: 23.65,
      latestHappyPlanet: 31.6,
      population: 1400000,
    },
    {
      country: 'Tunisia',
      continent: 'Africa',
      incomeLevel: 'Upper Middle Income',
      avgVal: 40,
      latestVal: 40,
      year: '',
      avgGDP: 128.3,
      avgGDPpercapita: 11512,
      latestGDP: 126,
      latestGDPpercapita: 11595,
      SEDA: 49.3,
      GINI: 40,
      avgHappyPlanet: 35.05,
      latestHappyPlanet: 43.9,
      population: 12000000,
    },
    {
      country: 'Turkiye',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 40.2,
      latestVal: 40.2,
      year: '',
      avgGDP: 2434.2,
      avgGDPpercapita: 28134,
      latestGDP: 2657.8,
      latestGDPpercapita: 30472,
      SEDA: 53.3,
      GINI: 40.2,
      avgHappyPlanet: 33.85,
      latestHappyPlanet: 41.3,
      population: 81000000,
    },
    {
      country: 'Turkmenistan',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: 40.8,
      latestVal: 40.8,
      year: '',
      avgGDP: 89.6,
      avgGDPpercapita: 15697,
      latestGDP: 92.3,
      latestGDPpercapita: 16194,
      SEDA: null,
      GINI: 40.8,
      avgHappyPlanet: 23.8,
      latestHappyPlanet: 33,
      population: 6000000,
    },
    {
      country: 'Uganda',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 39.5,
      latestVal: 39.5,
      year: '',
      avgGDP: 97.4,
      avgGDPpercapita: 2286,
      latestGDP: 102.9,
      latestGDPpercapita: 2398,
      SEDA: 30.9,
      GINI: 39.5,
      avgHappyPlanet: 32.1,
      latestHappyPlanet: 44.8,
      population: 43000000,
    },
    {
      country: 'Ukraine',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 25.5,
      latestVal: 25.5,
      year: '',
      avgGDP: 528.3,
      avgGDPpercapita: 13321,
      latestGDP: 535.6,
      latestGDPpercapita: 14220,
      SEDA: 52.5,
      GINI: 25.5,
      avgHappyPlanet: 33.65,
      latestHappyPlanet: 40.9,
      population: 45000000,
    },
    {
      country: 'United Arab Emirates',
      continent: 'Asia',
      incomeLevel: 'High Income',
      avgVal: null,
      latestVal: null,
      year: '',
      avgGDP: 646,
      avgGDPpercapita: 68826,
      latestGDP: 626.1,
      latestGDPpercapita: 66766,
      SEDA: 70.4,
      GINI: null,
      avgHappyPlanet: 34.3,
      latestHappyPlanet: 34.3,
      population: 9000000,
    },
    {
      country: 'United Kingdom',
      continent: 'Europe',
      incomeLevel: 'High Income',
      avgVal: 32.4,
      latestVal: 32.4,
      year: '',
      avgGDP: 3059.6,
      avgGDPpercapita: 48204,
      latestGDP: 3086.2,
      latestGDPpercapita: 49675,
      SEDA: 74.6,
      GINI: 32.4,
      avgHappyPlanet: 43.95,
      latestHappyPlanet: 56,
      population: 66000000,
    },
    {
      country: 'United States',
      continent: 'North America',
      incomeLevel: 'High Income',
      avgVal: 45,
      latestVal: 45,
      year: '',
      avgGDP: 20324.1,
      avgGDPpercapita: 65054,
      latestGDP: 20932.3,
      latestGDPpercapita: 69288,
      SEDA: 76,
      GINI: 45,
      avgHappyPlanet: 29.05,
      latestHappyPlanet: 37.4,
      population: 326000000,
    },
    {
      country: 'Uruguay',
      continent: 'South America',
      incomeLevel: 'High Income',
      avgVal: 41.6,
      latestVal: 41.6,
      year: '',
      avgGDP: 78,
      avgGDPpercapita: 23736,
      latestGDP: 78.1,
      latestGDPpercapita: 24625,
      SEDA: 64.2,
      GINI: 41.6,
      avgHappyPlanet: 46.8,
      latestHappyPlanet: 57.5,
      population: 3500000,
    },
    {
      country: 'Uzbekistan',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 36.8,
      latestVal: 36.8,
      year: '',
      avgGDP: 250.4,
      avgGDPpercapita: 7789,
      latestGDP: 270.1,
      latestGDPpercapita: 8497,
      SEDA: 43.1,
      GINI: 36.8,
      avgHappyPlanet: 41.6,
      latestHappyPlanet: 54.1,
      population: 32000000,
    },
    {
      country: 'Venezuela',
      continent: 'South America',
      avgVal: 39,
      latestVal: 39,
      year: '',
      avgGDP: null,
      avgGDPpercapita: null,
      latestGDP: null,
      latestGDPpercapita: null,
      SEDA: 43.1,
      GINI: 39,
      avgHappyPlanet: 41.25,
      latestHappyPlanet: 48.9,
      population: 32000000,
    },
    {
      country: 'Vietnam',
      continent: 'Asia',
      incomeLevel: 'Upper Middle Income',
      avgVal: 34.8,
      latestVal: 34.8,
      year: '',
      avgGDP: 982.1,
      avgGDPpercapita: 10699,
      latestGDP: 1032.4,
      latestGDPpercapita: 11553,
      SEDA: 50.8,
      GINI: 34.8,
      avgHappyPlanet: 44.35,
      latestHappyPlanet: 48.4,
      population: 96000000,
    },
    {
      country: 'Yemen',
      continent: 'Asia',
      avgVal: 37.9,
      latestVal: 37.9,
      year: '',
      avgGDP: null,
      avgGDPpercapita: null,
      latestGDP: null,
      latestGDPpercapita: null,
      SEDA: 23.9,
      GINI: 37.9,
      avgHappyPlanet: 33.7,
      latestHappyPlanet: 44.6,
      population: 28000000,
    },
    {
      country: 'Zambia',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 57.5,
      latestVal: 57.5,
      year: '',
      avgGDP: 61.4,
      avgGDPpercapita: 3576,
      latestGDP: 62.4,
      latestGDPpercapita: 3624,
      SEDA: 33.2,
      GINI: 57.5,
      avgHappyPlanet: 29.8,
      latestHappyPlanet: 34.4,
      population: 17000000,
    },
    {
      country: 'Zimbabwe',
      continent: 'Africa',
      incomeLevel: 'Lower Middle Income',
      avgVal: 43.2,
      latestVal: 43.2,
      year: '',
      avgGDP: 33.8,
      avgGDPpercapita: 2415,
      latestGDP: 33.6,
      latestGDPpercapita: 2444,
      SEDA: 29.7,
      GINI: 43.2,
      avgHappyPlanet: 25.35,
      latestHappyPlanet: 28.6,
      population: 17000000,
    },
  ],
};
